import { Button } from 'avo-ui'
import { formatDateMoment, innerHTML } from 'utils/utils'

export const TABLE_VOTER = {
    name: 'List Voter',
    column: [
        {
            name: 'Nama',
            key: 'name',
            render: ({ value }) => <div dangerouslySetInnerHTML={innerHTML(value)} />,
        },
        {
            name: 'Email',
            key: 'email',
        },
        {
            name: 'Tanggal Vote',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD MMMM YYYY HH:mm'),
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <Button type={'outline'} title={'Preview'} onClick={() => onClickItem(item)} />
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}
